import Edit from './Edit';
import List from './List';
export { Edit, List };



//////////////////
// WEBPACK FOOTER
// ./src/app/common/score/index.ts
// module id = 1274
// module chunks = 0